import "./Compliance.module.css";
import Header from "@/reusable_sections/Header";
import ExpansionToSyria from "./sections/ExpansionToSyria";
import CookiePolicy from "./sections/CookiePolicy";
import ApplicationAcknowledgementCertificate from "./sections/ApplicationAcknowledgementCertificate";
import Footer from "@/reusable_sections/Footer";
export default function CompliancePage() {
  return <div>
      <Header />
      <ExpansionToSyria />
      <CookiePolicy />
      <ApplicationAcknowledgementCertificate />
      <Footer />
    </div>;
}